import type { Location } from 'modules/core/lib/navigation/types'

export const careersNavigation = {
  path: 'careers-configuration',
  children: {
    appearance: {
      path: 'appearance',
    },
    content: {
      path: 'content',
      children: {
        header: {
          path: 'header',
        },
        values: {
          path: 'values',
          children: {
            new: {
              path: 'new',
            },
            edit: {
              path: ':id',
            },
          },
        },
        benefits: {
          path: 'benefits',
          children: {
            new: {
              path: 'new',
            },
            edit: {
              path: ':id',
            },
          },
        },
        team: {
          path: 'team',
        },
        jobs: {
          path: 'jobs',
        },
        offices: {
          path: 'offices',
          children: {
            upsert: {
              path: ':id',
            },
          },
        },
        terms: {
          path: 'terms',
        },
        legal_notice: {
          path: 'legal_notice',
        },
      },
    },
  },
} as const satisfies Location
